<template>
  <div class="sdg-container">
    <div class="header">VERKEHR UND STADTPLANUNG</div>
    <div class="separator"></div>

      <div class="content programme-block">

      <div class="programme-item">
        <div class="programme-title">UNSERE VISION #WEIDEN2040</div>
        Weiden ist eine grüne Stadt mit hoher Lebensqualität,
        abgasfreier und zuverlässiger Mobilität für alle und Straßen, auf denen
        Kinder gefahrlos spielen und Rad fahren können.
        <br>
        Das erreichen wir durch:
      </div>


      <div class="programme-item">
        <div @click="block1 = !block1" class="programme-title">
          <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block1 }"></i>
          Pilotprojekte "Verkehr der Zukunft"
        </div>
        <div v-if="block1">
          Projekte alternativer Straßennutzung, mit denen die beteiligten Bürger
          auf Wunsch das autofreie Leben testen können.
        </div>
      </div>

      <div @click="block2 = !block2" class="programme-item">
        <div class="programme-title">
        <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block2 }"></i>
          Verbesserung des ÖPNV
        </div>
        <div v-if="block2">
        Höhere Bustaktung und gute Vernetzung des öffentlichen Verkehrs in und um
        Weiden.
        <br>
          Von jeder Wohnung einfach und schnell erreichbare Haltestellen.
        </div>
      </div>

      <div @click="block3 = !block3" class="programme-item">
        <div class="programme-title">
        <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block3 }"></i>
          Attraktive Radinfrastruktur</div>

        <div v-if="block3">
          Zahlreiche Fahrradstraßen und überdachte Abstellplätze für Fahrräder
          mit Lademöglichkeit für Pedelecs.
        <br>
          Velo-Routen für Pendler.
        <br>
        </div>
      </div>
     
      <div @click="block4 = !block4" class="programme-item">
        <div class="programme-title">
        <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block4 }"></i>
          Fußläufigkeit verbessern
        </div>
        <div v-if="block4">
          Flaniermeilen mit ausreichender Breite und vergrößerung der
          Fußgängerzone in der Innenstadt.
        </div>
      </div>

     <div @click="block5 = !block5" class="programme-item">
        <div class="programme-title">
        <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block5 }"></i>
          Verkehrsbelastung senken
        </div>
        <div v-if="block5">
         „Kurzparkzonen“ für kurze Autos.
         Weniger Verkehrsbelastung in der Stadt, das stillt die Sehnsucht der
          Bürger nach Ruhe. 
        </div>
      </div>

     <div @click="block6 = !block6" class="programme-item">
        <div class="programme-title">
          <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block6 }"></i>
          Mobilität der Zukunft</div>

        <div v-if="block6">
          Die Mobilität der Zukunft ist umwelt- und klimafreundlich, intelligent,
          vernetzt und emissionsarm. Bahn und Bus, Fuß- und Radverkehr sind so
          attraktiv, dass sie ein gleichberechtigtes, schnelles, bequemes und
          effizientes Mobilitätsangebot für alle bieten. <br> Der Umstieg auf Alternativen
          jenseits des Autos ist klares Ziel für eine gesunde Umwelt, weniger Lärm
          und mehr Lebensqualität für unsere Stadt. Dafür brauchen wir ein noch
          besseres attraktiveres Angebot öffentlicher Verkehrsmittel, sichere und
          komfortable Infrastruktur für Fahrräder und Pedelecs, Car-Sharing- Angebote
          und eine gute Vernetzung aller Verkehrsmittel. Wir fördern Elektro-
          Mobilität und die zugehörige Ladeinfrastruktur in der Kommune sowie die
          schrittweise Umstellung auf emissionsfreie Busse.
       </div>
     </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sdg02',
data() {
    return {
      block1: false,
      block2: false,
      block3: false,
      block4: false,
      block5: false,
      block6: false,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';
</style>
